import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconUser';
/** Renders an SVG icon. */
const SvgUser = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M24 24a8 8 0 1 0-16 0v.474C8 25.317 8.683 26 9.526 26h12.948c.843 0 1.526-.683 1.526-1.526zm2 .474A3.526 3.526 0 0 1 22.474 28H9.526A3.526 3.526 0 0 1 6 24.474V24c0-5.523 4.477-10 10-10s10 4.477 10 10z"
      />
      <path fill="currentColor" d="M20 10a4 4 0 1 0-8 0 4 4 0 0 0 8 0m2 0a6 6 0 1 1-12 0 6 6 0 0 1 12 0" />
    </svg>
  );
};
SvgUser.displayName = displayName;
export default SvgUser;
